import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";

import { ConfirmDialog } from "@/components/ConfirmDialog";
import { removeClass } from "@/services/class";
import { configs } from "@/configs";
import { refetchQueries } from "@/utils";

import type { AxiosErrorWithData } from "@/client/api";

export type RemoveClassDialogProps = {
  open: boolean;
  onClose: (reason: "success" | "cancel") => void;
  id: string;
  fetchKeys?: string[];
};

export function RemoveClassDialog({
  open: isOpen,
  onClose,
  id,
  fetchKeys = [],
}: RemoveClassDialogProps) {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const { mutate: remove, isLoading } = useMutation(removeClass, {
    onSuccess: async () => {
      enqueueSnackbar("ลบ สำเร็จ", { variant: "success" });
      await refetchQueries({ queryClient, fetchKeys });
      onClose("success");
    },
    onError: (error: AxiosErrorWithData) => {
      console.error(error);
      enqueueSnackbar(
        error.response?.data.message ?? configs.unknownErrorMessage,
        { variant: "error" }
      );
    },
  });

  const onConfirm = () => remove(id);

  return (
    <ConfirmDialog
      maxWidth="xs"
      open={isOpen}
      onClose={() => onClose("cancel")}
      onConfirm={onConfirm}
      title="คุณต้องการลบหรือไม่"
      confirmMessage="ลบ"
      loading={isLoading}
    />
  );
}
